export const jonsLessonsTemplate = [
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603885313/lesson_template_vrntou.jpg',
    title:'Lesson 1. Practice conjugation',
    link:'jon-custom-lesson1'
  }
]